import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // state内部提供各组件的共享数据
  state: {
    userPullDownData:{
      TabPaneName:'1'//个人信息页左侧tab被选中的名称标识
    },

    // 主页头部导航的被选中标识
    homeIndexData:{
      activeIndex:'1'//导航被选中标识
    },

    // 面试题库,公共数据
    questionBankData:{
      // 面试题库，在我的查询列表点击编辑后，保存当前编辑的数据，用于下一个组件获取，进行数据反显
      questionBankEditData:{}
    }

  },
  getters: {
  },
  // mutations：内部提供方法，用来改变state中的属性值
  mutations: {
    // 改变TabPaneName的值
    changeTabPaneName(state,tabName){
      state.userPullDownData.TabPaneName=tabName;
    },

    // 改变主页导航被选中标识
    changeActiveIndex(state,index){
      state.homeIndexData.activeIndex=index;
    },

    // 改变面试题库,公共数据，当前编辑的数据
    changeQuestionBankEditData(state,editData){
      state.questionBankData.questionBankEditData=editData;
    },

    // 改变面试题库,公共数据，当前编辑的数据持久化到本地
    setLocalStorageBankEditData(state){
      const editData=JSON.stringify(state.questionBankData.questionBankEditData);
      localStorage.setItem('questionBankEditData',editData);
    },
    // 改变面试题库,公共数据，当前编辑的数据进行恢复
    getLocalStorageBankEditData(state){
      const editData = JSON.parse(localStorage.getItem('questionBankEditData'));
      state.questionBankData.questionBankEditData=editData;
    }
  },
  actions: {
  },
  modules: {
  }
})
